import 'twin.macro';
import React from 'react';

interface Props {
  schoolName?: string;
  schoolyear?: number;
}
// TODO: get correct property to format schoolyear
export function SchoolSchoolyearInfo(props: Props) {
  const { schoolName, schoolyear } = props;
  return (
    <div tw="text-right text-muted text-xs">
      <div tw="truncate">{schoolName || ''}</div>
      <div tw="text-right">
        {schoolyear && <div>{`${schoolyear - 1} - ${schoolyear}`}</div>}
      </div>
    </div>
  );
}
